import apiService from "../../../../api/rest";

export const getDefaultState = () => {
  return {
    environment: "prod",
    gitVersion: "",
    gitTag: "",
    releaseVersion: ""
  };
};

const state = getDefaultState();

const getters = {
  getAppEnvironment(state) {
    return state.environment;
  },
  getAppGitVersion(state) {
    return state.gitVersion;
  },
  getReleaseVersion(state) {
    return state.releaseVersion;
  },
  getGitTag(state) {
    return state.gitTag;
  }
};

const actions = {
  async getVersionEnv({ commit }) {
    const AppInfo = await apiService.getAppInfo();
    commit("setAppInfo", AppInfo);
  }
};

const mutations = {
  setAppInfo(state, data) {
    state.environment = data.environment;
    state.gitVersion = data.git_version;
    state.gitTag = data.git_tag;
    state.releaseVersion = data.release_version;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
